import { memo, PropsWithChildren } from 'react';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';
import Button from '@/components/atoms/Button/Button';
import Icon from '@/components/atoms/Icon';
import { classnames } from '@/libs/utils';
import { MediaPickerModalProps } from '@/Pages/BrandKit/types';

function MediaPickerModal({
  isOpen,
  onClose,
  title,
  onConfirm,
  confirmDisabled = false,
  confirmLabel = 'Add Selected',
  isConfirmLoading = false,
  children
}: PropsWithChildren<MediaPickerModalProps>): JSX.Element {
  return (
    <ContentDialog
      isOpen={isOpen}
      setIsOpen={onClose}
      title={title}
      size="large"
      titleSize="medium"
      showDivider={false}
      titleClassName="p-5 text-base text-slate-950"
      panelClassNames="!w-[712px] !max-w-[712px]"
    >
      <div className="flex flex-col gap-5 px-5 pb-5">{children}</div>

      <div className="sticky bottom-0 flex items-center justify-end gap-3 border-t border-slate-200 bg-white p-4">
        <Button variation="text" trackingId="media-picker-cancel" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variation="filled"
          trackingId="media-picker-confirm"
          disabled={confirmDisabled || isConfirmLoading}
          onClick={onConfirm}
          className={classnames({
            '!bg-slate-400 !text-white hover:!bg-slate-400': isConfirmLoading
          })}
        >
          {isConfirmLoading ? (
            <>
              <Icon name="IconLoader2" size={16} className="mr-1.5 animate-spin" />
              Uploading
            </>
          ) : (
            confirmLabel
          )}
        </Button>
      </div>
    </ContentDialog>
  );
}

export default memo(MediaPickerModal);
